<template>
  <div class="products-list-component" ref="productsList">
    <div class="area">
      <div
        class="row products-list-container"
        v-animated-show="utils.handleScroll"
      >
        <Description
          class="col-6 col-md-12 big"
          ref="categoryDescription"
          :title="category.title"
          :desc="category.desc"
          v-if="category && category.title"
        />
        <div class="spacer col-1 md-hidden"></div>
        <div class="pros-container col-5 col-md-12 gap-offset">
          <div class="art-img">
            <img
              :src="category.sub.img.src"
              :alt="category.sub.img.alt"
              class="art"
              v-if="category && category.sub && category.sub.img"
            />
          </div>
          <Description
            class="pros mini"
            ref="categoryDescription"
            :title="category.sub.title"
            :desc="category.sub.desc"
            v-if="category && category.sub && category.sub.title"
          />
        </div>
        <masonry
          :cols="{ default: 2, 1024: 1 }"
          :gutter="0"
          class="masonry-grid col-12"
        >
          <Description
            class="mini icon-top"
            ref="categoryDescription"
            :title="subcategory.title"
            :desc="subcategory.desc"
            :icon="subcategory.icon"
            v-if="subcategory && subcategory.title"
          />
          <template v-if="products">
            <section
              class="list-section-banner"
              v-for="(l, i) in products.list"
              ref="products"
              :key="i"
            >
              <div class="content">
                <a :href="'/product' + l.id">
                  <div class="art-img">
                    <img :src="l.img.src" :alt="l.img.alt" class="art" />
                  </div>
                  <Description
                    class="mini"
                    ref="bannerDescription"
                    :isMoreTop="true"
                    :title="l.title"
                    :button="l.button"
                    :href="l.href"
                    :icon="l.icon"
                    v-if="l.title"
                  />
                </a>
              </div>
            </section>
          </template>
        </masonry>

        <a
          v-if="products && products.list.length > 0 && hasMore"
          href="/"
          @click.prevent="
            () => {
              loadMore();
            }
          "
          class="button-load-more"
        >
          <div class="button nav-arrow nav-arrow--prev"></div>
          <span>Загрузить еще</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
import firestoreUtils from "../firestore-utils";
export default {
  name: "ProductsList",
  props: {
    categories: Object,
  },
  data() {
    return {
      products: undefined,
      utils: utils,
      currentCategory: 1,
      currentSubcategory: 1,
      hasMore: true,
      countPerPage: 5,
    };
  },
  computed: {
    category() {
      console.log(this.currentCategory);
      return this.getCategoryById(this.currentCategory);
    },
    subcategory() {
      if (this.currentSubcategory !== -1) {
        return this.getSubcategoryById(this.currentSubcategory);
      } else {
        return undefined;
      }
    },
  },
  methods: {
    loadMore() {
      this.fetchProducts();
    },
    fetchProducts() {
      let where = {};
      if (this.subcategory) {
        where = {
          field: "subcategory",
          condition: "==",
          value: this.subcategory.id,
        };
      } else {
        where = {
          field: "category",
          condition: "==",
          value: this.category.id,
        };
      }
      {
      }
      firestoreUtils
        .fetchWithFilter("productslist", where, this.countPerPage, this.last)
        .then(result => {
          this.last = result.last;
          if (this.products) {
            this.products.list = [...this.products.list, ...result.data];
          } else {
            this.products = { list: result.data };
          }
          this.hasMore = result.data.length === this.countPerPage;
          // this.metaTitle = this.data.meta.title;
          // this.metaDescription = this.data.meta.description;
          // this.metaKeywords = this.data.meta.keywords;
        })
        .catch(err => {
          console.log(err);
          this.products = undefined;
        });
    },
    getCategoryById(id) {
      return this.categories.list.find(item => item.id === id);
    },
    getSubcategoryById(id) {
      return this.categories.subcategories.list.find(item => item.id === id);
    },
    updateCategories() {
      if (this.$route.query.subcat) {
        this.currentSubcategory = parseInt(this.$route.query.subcat);
      } else {
        this.currentSubcategory = -1;
      }
      this.currentCategory = parseInt(this.$route.query.cat);
      if (!this.currentCategory) {
        this.currentCategory = 1;
      }
      if (!this.currentSubcategory) {
        this.currentSubcategory = 1;
      }
    },
  },
  watch: {
    $route() {
      this.updateCategories();
      this.last = undefined;
      this.products = undefined;
      this.fetchProducts();
    },
  },
  mounted() {
    this.updateCategories();
    this.last = undefined;
    this.products = undefined;
    this.fetchProducts();
  },
};
</script>

<style lang="scss">
.products-list-component {
  @extend %page-block;
  .masonry {
    column-gap: 80px;
    column-fill: balance;
  }
  .masonry-grid {
    @media all and (max-width: $md) {
      grid-gap: 16px;
    }
    display: grid !important;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    grid-gap: 26px;
    > div {
      &:nth-child(2n - 1) {
        @media all and (max-width: $md) {
          grid-column: 1 / span 12;
          margin-left: 0px;
          margin-right: 0;
        }
        width: unset !important;
        grid-column: 1 / span 5;
        margin-left: 0px;
        margin-right: -26px;
      }
      &:nth-child(2n) {
        @media all and (max-width: $md) {
          grid-column: 1 / span 12;
          margin-left: 0px;
          margin-right: 0;
        }
        width: unset !important;
        grid-column: 8 / span 5;
        margin-left: -26px;
        margin-right: 0px;
      }
    }
  }
  .float-title {
    @media all and (max-width: $md) {
      margin-bottom: 70px;
    }
    @extend %float-title;
    margin-right: 30%;
  }
  .products-list-container {
    @media all and (max-width: $md) {
      grid-row-gap: 36px;
    }
    grid-row-gap: 36px;
  }

  .button-load-more {
    @media all and (max-width: $md) {
      grid-column: 1 / span 12;
    }
    grid-column: 1 / span 12;
    justify-self: center;
    justify-items: center;
    display: grid;
    grid-gap: 15px;
    @extend %text-h5;
    .button {
      width: 42px;
      &::before {
        transform: rotate(-90deg);
      }
    }
    span {
    }
    transition: color 0.5s;
    color: $text-main-quart;

    &:hover {
      border-color: transparent;
      color: $text-main;
      .button {
        background: $color-accent;
        &::before {
          color: $text-inverse-main;
        }
      }
    }
  }
  .description.icon-top {
    .icon {
      height: 42px;
      font-size: 33px;
      &::before {
        margin-left: 0 !important;
      }
    }
  }
  .list-section-banner {
    margin-top: 30px;
    @media all and (max-width: $md) {
      text-align: center;
    }
    .art-img {
      @media all and (max-width: $md) {
        text-align: center;
      }
      img {
        max-width: 300px;
        margin-left: -26px;
      }
    }
  }
  .pros-container {
    @media all and (max-width: $md) {
      background: $bg-grey-dark;
      margin-top: 70px;
      padding-bottom: 20px;
      position: relative;
      grid-row: 1;
    }
    .pros {
      @media all and (max-width: $md) {
        margin-top: 35px;
      }
      margin-top: 0px;
      padding-bottom: 20px;
      .description-content {
        @media all and (max-width: $md) {
          grid-gap: 9px;
        }
      }
    }
    &::before {
      @media all and (max-width: $md) {
        background: $bg-grey-dark;
        margin-left: -16px;
        margin-right: -50px;
        position: relative;
        display: block;
        position: absolute;
        left: -16px;
        right: -16px;
        bottom: 0;
        top: 0;
        content: "";
        z-index: -1;
      }
    }
    .art-img {
      @media all and (max-width: $md) {
        position: absolute;
        width: 314px;
        height: 195px;
        top: -62px;
        left: -65px;
        margin-top: -40px;
      }
      position: relative;
      left: -65px;
      margin-top: -40px;
    }
  }
}
</style>
